import React, { ReactNode } from 'react';
import { withRouter } from 'react-router';
import { ErrorComponentView } from './ErrorComponentView';
import { WprAnchor } from '../../wpr-framework/component/controls/WprAnchor';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { WprSpan } from '../../wpr-framework/component/controls/WprSpan';
import { FooterComponent } from '../common/footer/FooterComponent';
import { HeaderComponent } from '../common/header/HeaderComponent';

/**
 * エラー表示コンポーネント
 */
class ErrorComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new ErrorComponentView(), props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<main className="page-error">
					<div className="message">
						<h1>申し訳ありません以下のエラー内容をご確認ください</h1>
						<div className="texts">
							<p><WprSpan name="errorMsg" view={this.view} ></WprSpan></p>
						</div>
					</div>
					<div className="prev">
						<WprAnchor className="c-btn-prev" view={this.view} name="prev" >
							<span>戻る</span>
						</WprAnchor>
					</div>
				</main>
				<FooterComponent />
			</>
		);
	}
	// --------------------------------------------------------------------------
}

export default withRouter(ErrorComponent);